export default "__VITE_ASSET__572635b9__"